/**
 * WordPress dependencies
 */
import { store, getElement } from '@wordpress/interactivity';

const { callbacks } = store('bb/ticker', {
  callbacks: {
    initTicker() {
      const el = getElement();
      const index = el?.attributes['data-index'];
      callbacks.duplicateContent(index);
    },
    duplicateContent(index) {
      const { ref } = getElement();

      const elWidth = ref.offsetWidth + 32;
      const windowWidth = window.screen.width;

      const duplicateNum = Math.ceil(windowWidth / elWidth) - 1;

      const parent = document.getElementById(`ticker-wrapper-${index}`);

      for (let i = 0; i < duplicateNum; i++) {
        const clone = ref.cloneNode(true);
        parent.appendChild(clone);
      }
    },
  },
});
